import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner8 from "../assets/banner8.jpg";
import banner2 from "../assets/banner2.jpg";
import banner1 from "../assets/banner1.jpg";
import { FaHandshake, FaTruckMoving, FaClipboardList, FaCogs } from "react-icons/fa";
import { MdAnalytics, MdAttachMoney, MdElderly, MdHelp, MdListAlt, MdLocalHospital, MdPhone, MdPsychology, MdSchool, MdVolunteerActivism, MdWhatsapp, MdWork  } from "react-icons/md";

export default function ServicesContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const processSteps = [
    "Customer Request – Clients share their material or transport requirements with us.",
    "Quotation & Proposal – We provide a detailed quotation based on the request.",
    "Agreement/Contract – Upon approval, we formalize engagement through a supply contract or purchase order.",
    "Delivery & Fulfillment – Materials are procured, quality-checked, and delivered on schedule.",
    "Payment & Support – Payment terms are honored, with after-sales support where needed."
  ];

  const coreServices = [
    {
      title: "Project Support Services",
      icon: <FaCogs size={30} color="var(--secondaryColor)" />,
      content: [
        "Procurement Services – Sourcing and supplying materials as per project requirements.",
        "Project Support – End-to-end assistance to minimize client workload.",
        "Installation Services – Professional installation of supplied materials and systems.",
        "After-Sales Support – Warranty services, maintenance, and troubleshooting."
      ],
			banner: banner8,
    },
    {
      title: "Transport & Logistics Services",
      icon: <FaTruckMoving size={30} color="var(--secondaryColor)" />,
      content: [
        "Material Transportation – Safe and timely delivery of construction materials.",
        "Cargo Services – Transportation of general cargo and equipment.",
        "Logistics Solutions – Supply chain management and coordination."
      ],
			banner: banner2,
    },
  ];

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready)
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div
      className="MainBodySection bg-background"
      style={{ paddingTop: "50px", paddingBottom: "50px" }}
    >
      <div className="container">
        {/* --- TITLE --- */}
        <div className="row mb-4">

          {/* --- INTRO --- */}
          <div className="col-md-12 mb-4">
            <h6
              style={{ fontSize: "18px" }}
              className="mt-3 mb-3"
            >
              Beyond MVC sponsorship, <b>TCHI</b> implements multi-sectoral programs that address the holistic needs of vulnerable groups.
            </h6>
          </div>

          <div className="col-md-12">
            <div className="row g-3">
                {/* Project Support Services */}
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdSchool
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Education & Vocational Training
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Facilitating formal education, vocational skills, and youth empowerment programs that equip children and young people with knowledge and employable skills.
                    </h6>
                  </div>
                </div>
  
                {/* Transport & Logistics Services */}
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdLocalHospital
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Health & Nutrition
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Implementing maternal and child health initiatives, nutrition programs, and HIV prevention and care services to improve overall well-being.
                    </h6>
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdPsychology
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Psychosocial Support
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Offering counseling, mentoring, and community-based support to address emotional and social challenges faced by children, adolescents, and families.
                    </h6>
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdWork
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Women’s Economic Empowerment
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Enhancing women’s financial independence through entrepreneurship training, income-generating projects, and sustainable livelihood programs.
                    </h6>
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdElderly
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Elderly Care
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Providing support for the elderly through social inclusion initiatives, health interventions, and community engagement programs.
                    </h6>
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div
                    className="card shadow-sm p-2"
                    style={{
                      borderRadius: "12px",
                      background: "white",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div className="d-flex gap-3 align-items-center p-3">
                      <MdAnalytics
                        size={64}
                        color="var(--secondaryColor)"
                      />
                      <h5 className="text-primary font-bold">
                        Research, Monitoring & Evaluation
                      </h5>
                    </div>
                    <h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
                      Strengthening data collection, program assessment, and evidence-based strategies for effective and sustainable interventions.
                    </h6>
                  </div>
                </div>
  
              </div>
          </div>
        </div>

        {/* --- CALL TO ACTION BUTTONS --- */}
        <div className="container text-center mt-4">
          <button
            style={{ margin: "10px" }}
            className="btn btn-padded btn-outline-primary btn-rounded"
            onClick={() => {
              appContext.navTo({ item: "donations" });
            }}
          >
            <MdVolunteerActivism size={24} /> DONATE
          </button>

          <button
            style={{ margin: "10px" }}
            className="btn btn-padded btn-primary btn-rounded"
            onClick={() => {
              appContext.navTo({ item: "contact_us" });
            }}
          >
            <MdPhone size={24} /> CONTACT US
          </button>
        </div>
      </div>
    </div>
  );
}
